export default function CTASection() {
  return (
    <section className="relative py-24 md:py-36 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20office%20corner%20with%20macrame%20wall%20hanging%2C%20wooden%20desk%20with%20laptop%20showing%20data%20analytics%2C%20ceramic%20coffee%20cup%2C%20dried%20pampas%20grass%20in%20vase%2C%20soft%20golden%20hour%20sunlight%20through%20sheer%20curtains%2C%20bohemian%20Scandinavian%20interior%2C%20calm%20productive%20atmosphere&width=1600&height=900&seq=cta-bg-unique-lifestyle&orientation=landscape"
          alt="Hipobuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/30 to-black/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          {/* Left - Title + Button */}
          <div className="md:w-1/2">
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading text-background-50 leading-none mb-8">
              Hipobuy<br />spreadsheet
            </h2>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3.5 rounded-full bg-background-50 text-foreground-900 text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap group"
            >
              <span>Acheter maintenant</span>
              <span className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center text-background-50 text-xs"></i>
              </span>
            </a>
          </div>

          {/* Right - Description */}
          <div className="md:w-1/3">
            <p className="text-background-200/90 text-base md:text-lg leading-relaxed">
              Optimisez vos données avec l&apos;outil d&apos;automatisation le plus avancé du marché. Interface intuitive, IA intégrée, résultats immédiats.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}